export const FLOATING_BOX_DEFAULT_OFFSET = 2;
export const FLOATING_BOX_DEFAULT_POPUP_KIND = 'menu';
